import { module } from 'modujs';
import { gsap } from 'gsap';
import { queryClosestParent } from '../utils/html';
export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)

        // UI
        this.$el = this.el

        // Events
        this.events = {
            click: {
                toggler: 'toggle'
            }
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind)
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind)
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.resize()
    }

    onFontsLoaded() {
        this.resize()
    }

    ///////////////
    // Methods
    ///////////////
    toggle(e) {
        let item = e.curTarget
        let parent = queryClosestParent(item, '[data-accordions="item"]')

        if (parent.classList.contains('is-open')) {
            this.close(parent, item)
        } else {
            this.open(parent, item)
        }
    }

    open(parent, item) {
        let collapsible = parent.querySelector('[data-accordions="inner"]')
        parent.classList.add('is-open')

        gsap.to(collapsible, 0.3, {
            height: this.compute(parent.querySelector('[data-accordions="content"]')).height,
            onComplete: () => {
                this.call('update', null, 'Scroll')
                this.call('scrollTo', { target: item, options: { offset: -100, duration: 450 } }, 'Scroll', 'main')

                item.setAttribute('aria-expanded', 'true')
            }
        })
    }

    close(parent, item) {
        let collapsible = parent.querySelector('[data-accordions="inner"]')
        parent.classList.remove('is-open')

        gsap.to(collapsible, 0.3, {
            height: 0,
            onComplete: () => {
                this.call('update', null, 'Scroll')
                item.setAttribute('aria-expanded', 'true')
            }
        })
    }

    compute(item) {
        return item.getBoundingClientRect();
    }

    resize() {
        const activeItem = Array.from(this.$('item')).find((item) => {
            return item.classList.contains('is-open')
        })

        if (!activeItem) return

        const collapsible = activeItem.querySelector('[data-accordions="inner"]')

        gsap.set(collapsible, { height: this.compute(activeItem.querySelector('[data-accordions="content"]')).height })
    }
}